import { apiFetch } from '@/platform/lib/api';

export type FeedbackCategory = 'feature' | 'bug' | 'improvement' | 'other';
export type FeedbackStatus = 'open' | 'under_review' | 'planned' | 'shipped' | 'declined';

export interface Suggestion {
  id: string;
  title: string;
  body: string;
  category: FeedbackCategory;
  authorId: string;
  status: FeedbackStatus;
  upvoteCount: number;
  adminResponse?: string;
  createdAt: string;
  updatedAt: string;
  myUpvoted?: boolean;
}

export type FeedbackCapabilities = {
  itsm: boolean;
  upvotes: boolean;
  editOwn: boolean;
  sortUpvotes: boolean;
};

export function fetchFeedbackConfig() {
  return apiFetch<{ capabilities: FeedbackCapabilities }>('/feedback/config');
}

export function listFeedback(params?: {
  sort?: 'upvotes' | 'recent';
  category?: FeedbackCategory;
  status?: FeedbackStatus;
}) {
  const q = new URLSearchParams();
  if (params?.sort) q.set('sort', params.sort);
  if (params?.category) q.set('category', params.category);
  if (params?.status) q.set('status', params.status);
  const qs = q.toString();
  return apiFetch<{ suggestions: Suggestion[]; capabilities?: FeedbackCapabilities }>(
    `/feedback${qs ? `?${qs}` : ''}`,
  );
}

export function getFeedback(id: string) {
  return apiFetch<Suggestion>(`/feedback/${id}`);
}

export function submitFeedback(body: { title: string; body: string; category: FeedbackCategory }) {
  return apiFetch<Suggestion>('/feedback', { method: 'POST', body: JSON.stringify(body) });
}

export function updateFeedback(id: string, body: Partial<{ title: string; body: string; category: FeedbackCategory }>) {
  return apiFetch<{ status: string }>(`/feedback/${id}`, { method: 'PATCH', body: JSON.stringify(body) });
}

export function toggleUpvote(id: string) {
  return apiFetch<{ upvoteCount: number; upvoted: boolean }>(`/feedback/${id}/upvote`, { method: 'POST' });
}

export const STATUS_LABELS: Record<FeedbackStatus, string> = {
  open: 'Open',
  under_review: 'Under review',
  planned: 'Planned',
  shipped: 'Shipped',
  declined: 'Declined',
};

export const CATEGORY_LABELS: Record<FeedbackCategory, string> = {
  feature: 'Feature',
  bug: 'Bug',
  improvement: 'Improvement',
  other: 'Other',
};
